// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".PgH81{padding:1.5rem;border-radius:.25rem;border:1px solid #9fa0a0;text-align:center}._2uUPC{margin:.375rem 0 1.25rem}._19iUS{display:-ms-inline-flexbox;display:inline-flex;-ms-flex-pack:center;justify-content:center}@media(min-width:1024px){._19iUS>*{margin-right:1rem}}@media(max-width:1023px){._19iUS{-ms-flex-direction:column;flex-direction:column}._19iUS>*{margin-bottom:1rem}}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "PgH81",
	"title": "_2uUPC",
	"buttonGroup": "_19iUS"
};
module.exports = exports;
